import apiClient from '@/service/apiClient';

export type ResGetReviewTop10 = {
  isSuccess: boolean;
  code: number;
  message: string;
  correlationId: string;
  result: Array<{
    id: number;
    name: string;
    location: string;
    categoryId: number;
    categoryName: string;
    villageName: string;
    price: number;
    originPrice: number;
    thumbnailUrl: string;
    productType: string;
    reviewCount: number;
  }>;
};

export const getReviewTop10 = async (): Promise<ResGetReviewTop10> => {
  const { data } = await apiClient.get<ResGetReviewTop10>('/app/products/v2/review/top-10');
  return data;
};
